<template>
  <div>
    <dashboard-panel no-collapse :title="panelTitle">
      <manual-loans-list />
    </dashboard-panel>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import DashboardPanel from '@/modules/dashboard/components/DashboardPanel.vue';
import ManualLoansList from '@/modules/manual-loan/components/ManualLoansList.vue';
import i18n from '@/localisation/i18n';

@Component({
  provide() {
    return {
      gridStateKey: 'ManualLoansView',
    };
  },
  components: {
    DashboardPanel,
    ManualLoansList,
  },
})
export default class ManualLoansView extends Vue {
  protected get panelTitle(): string {
    return i18n.t('sidebar.items.manualLoans') as string;
  }
}
</script>

<style lang="scss"></style>
